function trimTrailingSlash(url) {
  return String(url || '').replace(/\/+$/, '');
}

function normalizeApiUrl(url) {
  let normalized = trimTrailingSlash(url);
  if (typeof window !== 'undefined') {
    const pageIsHttps = window.location?.protocol === 'https:';
    if (pageIsHttps && normalized.startsWith('http://')) {
      normalized = `https://${normalized.slice('http://'.length)}`;
    }
  }
  return normalized;
}

export function resolveApiUrl() {
  // Important: cookie auth relies on "same-site".
  // `localhost` and `127.0.0.1` are different sites, so if frontend is on `localhost:3000`
  // but API is `127.0.0.1:8000`, SameSite=Lax cookies won't be sent and you get 401 loops.
  // Therefore: default to using the *same host* as the page in local dev.
  const devLocalApi = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';

  // 1) Build-time env (Create React App)
  const envUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE;
  if (envUrl) return normalizeApiUrl(envUrl);

  // 2) Optional runtime override (if we ever inject it via index.html)
  if (typeof window !== 'undefined') {
    const runtimeUrl = window.__KANPLAN_API_URL || window.KANPLAN_API_URL;
    if (runtimeUrl) return normalizeApiUrl(runtimeUrl);

    // 3) Derive from current host
    const { protocol, hostname } = window.location;

    // Local dev
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Prefer explicit :8000 on the same host.
      return normalizeApiUrl(`${protocol}//${hostname}:8000`);
    }

    // Deployed default: app.<domain> -> api.<domain>
    if (hostname.startsWith('app.')) {
      return normalizeApiUrl(`${protocol}//api.${hostname.slice(4)}`);
    }

    // Stage frontend: stage.<domain> -> api.stage.<domain>
    if (hostname.startsWith('stage.')) {
      return normalizeApiUrl(`${protocol}//api.stage.${hostname.slice('stage.'.length)}`);
    }

    // Fallback: assume api.<hostname>
    return normalizeApiUrl(`${protocol}//api.${hostname}`);
  }

  // Final fallback
  return devLocalApi;
}
